import {
    SUCS_HOST,
    SUMFS_HOST,
    getEnvName
} from '@/config'
import request from '@/service/apiConfig/request'
const originSumfsHost = SUMFS_HOST[getEnvName()]
const originSucsHost = SUCS_HOST[getEnvName()]
/** 
 * @description 总裁榜单推荐TestB接口

*/
export const queryPresidentCommodity = (params) => {
    return request.jsonp(originSumfsHost + '/sumis-web/newHomePage/queryPresidentCommodity.do', params)
}
/** 
 * @description 3007_推客高佣商品数据

*/
export const queryHighCommissionCommodity = (params) => {
    return request.jsonp(originSumfsHost + '/sumis-web/leaderInverstment/queryHighCommissionCommodity.do', params)
}
/** 
 * @description 0252  9.9专区接推荐

*/
export const queryNewRecommendCommodity = (params) => {
    return request.jsonp(originSumfsHost + '/sumis-web/newHomePage/queryNewRecommendCommodity.do', params)
}
/** 
 * @description 0252  9.9专区接推荐

*/
export const queryCouponInfo = (params) => {
    return request.jsonp(originSucsHost + '/promotionCoupon/queryCouponInfo.json', params)
}
